import { Location } from 'history';

import routes from '~/utils/routes';

export const locationIsHomeRoute = (location: Location): boolean => {
  const homeRoutePaths = routes.filter(x => x.isHomeRoute).map(x => x.path);
  return homeRoutePaths.includes(location.pathname);
};
